import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MultiSelectComponent } from './multi-select.component';
import { MultiSelectFooterTemplateDirective, MultiSelectHeaderTemplateDirective } from './multi-select-templates.directive';

@NgModule({
    imports: [CommonModule, FormsModule, ScrollingModule, MatFormFieldModule, MatSelectModule, MatInputModule],
    declarations: [MultiSelectComponent, MultiSelectFooterTemplateDirective, MultiSelectHeaderTemplateDirective],
    exports: [MultiSelectComponent, MultiSelectFooterTemplateDirective, MultiSelectHeaderTemplateDirective],
})
export class UiMultiSelectModule {}

